import { createWebHistory, createRouter } from 'vue-router';
import adminRoutes from './AdminRoutes';
import authRoutes from './authRoutes';
import authAssessmentRoutes from './authAssessmentRoutes';
import store from '@/vuex/store';
import { getItem } from '@/utility/localStorageControl';

const { dispatch } = store;

const routes = [
  {
    name: 'Admin',
    path: '/',
    component: () => import(/* webpackChunkName: "admin" */ '@/layout/withAdminLayout.vue'),
    children: [...adminRoutes],
    meta: { auth: false },
  },
  {
    name: 'Auth',
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/layout/withAuthLayout.vue'),
    children: [...authRoutes],
    meta: { auth: false },
  },
  {
    name: 'AuthAssessment',
    path: '/auth-assessment',
    component: () => import(/* webpackChunkName: "auth-assessment" */ '@/layout/withAuthLayout.vue'),
    children: [...authAssessmentRoutes],
    meta: { auth: true },
  },
  {
    name: 'PrivacyPolicy',
    path: '/privacy-policy',
    component: () => import(/* webpackChunkName: "privacy-policy" */ '@/view/pages/PrivacyPolicy.vue'),
    meta: { auth: false },
  },
  {
    name: 'Unauthorized',
    path: '/unauthorized',
    component: () => import(/* webpackChunkName: "unauthorized" */ '@/view/pages/404.vue'),
    meta: { auth: false },
  },
];

const router = createRouter({
  history: createWebHistory(
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_SUB_ROUTE
        ? process.env.VUE_APP_SUB_ROUTE
        : process.env.BASE_URL
      : process.env.BASE_URL,
  ),
  linkExactActiveClass: 'active',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === 'PrivacyPolicy' || to.name === 'Unauthorized') {
    next();
  } else if (to.path.startsWith('/auth-assessment/login')) {
    // Halaman login assessment, biarkan
    next();
  } else if (to.path.startsWith('/assessment')) {
    // Route assessment yang butuh auth
    if (store.state.assessmentAuth.login) {
      // Sudah login assessment
      next();
    } else {
      // Belum login assessment, redirect ke login
      next('/auth-assessment/login');
    }
  } else if (to.meta.auth) {
    // Route auth biasa
    if (to.path === '/auth/login') {
      // Jika ke halaman login, biarkan
      next();
    } else if (store.state.auth.login) {
      // Sudah login
      // Check if route requires specific roles
      if (to.meta.roles && to.meta.roles.length > 0) {
        const userProfile = getItem('profile_plnbb');
        // Check if user has any of the required roles
        if (userProfile && userProfile.roles && userProfile.roles.some(role => to.meta.roles.includes(role.name))) {
          next();
        } else {
          // User doesn't have the required role
          next('/unauthorized');
          dispatch('logOut');
        }
      } else {
        // No specific roles required
        next();
      }
    } else {
      // Belum login, redirect ke login
      next('/auth/login');
    }
  } else {
    next();
  }
});

export default router;
